<template>
  <div class="wrap">
    <div class="loading-box" v-if="isLoad">
      <div class="loading">
        <div><i class="fad fa-spinner"></i></div>
        <span>Loading...</span>
      </div>
    </div>
    <h2>
      <img src="@/assets/img/logo2.svg" alt="愛薇樂嚴選內衣 - 計件系統" />
      愛薇樂嚴選內衣 - 計件系統
    </h2>
    <div class="data-area">
      <div class="input-box">
        <label>貨號單名稱</label>
        <p>{{ orderInfo.name }}</p>
      </div>
      <div class="input-box">
        <label>顏色</label>
        <p>{{ orderInfo.color }}</p>
      </div>
      <div class="input-box">
        <label>貨號單編號</label>
        <p>{{ orderInfo.id }}</p>
      </div>
      <div class="input-box">
        <label>日期</label>
        <p>{{ orderInfo.date }}</p>
      </div>
    </div>
    <div class="staff-group"></div>
    <div class="list-area">
      <div class="tit-box">
        <h3>{{ recodeDate }} 填寫紀錄</h3>
      </div>
      <SumItem
        v-for="(item, index) in list"
        :key="index"
        :itemName="item.item_name"
        :memList="item.detail"
      />
      <div class="btn-area">
        <div class="add-btn cancle-btn" @click="backPage">
          <i class="fa fa-chevron-left"></i>
          返回
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SumItem from "@/components/SumItem.vue";

import { apiRecordLog } from "@/api/api.js";

export default {
  data() {
    return {
      orderId: "",
      isLoad: true,
      orderInfo: {
        id: "-", //20201211001
        name: "-", //8118胸罩
        date: "-", //2020/12/11
        color: "-", //白
      },
      recodeDate: "-",
      list: [
        {
          item_name: "-", //itemName
          detail: [
            //memList
            {
              employee_name: "-", //name
              order_size: "-", //size
              count: "-", //done
            },
          ],
        },
      ],
    };
  },
  mounted() {
    var nowId = this.$route.params.id;
    console.log("id：", nowId);
    this.orderId = nowId;
    //=== 取得填單紀錄 ===
    apiRecordLog({ order_id: this.orderId })
      .then((result) => {
        console.log(result.data);
        if (result.data.message == "Success") {
          //== 放入項目 ==
          this.recodeDate = result.data.data.date;
          this.list = result.data.data.item_info;
          var { order_name, color, order_id, date } = result.data.data;
          this.orderInfo.id = order_id;
          this.orderInfo.name = order_name;
          this.orderInfo.color = color;
          this.orderInfo.date = date;
          this.isLoad = false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    //=== 回上一頁 ===
    backPage() {
      this.$router.go(-1);
    },
  },
  components: {
    SumItem,
  },
};
</script>